var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.27767C4.62134 5.27767 5.125 4.75535 5.125 4.111C5.125 3.46667 4.62134 2.94434 4 2.94434C3.37866 2.94434 2.875 3.46667 2.875 4.111C2.875 4.75535 3.37866 5.27767 4 5.27767Z",
    stroke: "#3E4159",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C5.65686 7.22222 7 5.82934 7 4.11111C7 2.39289 5.65686 1 4 1C2.34314 1 1 2.39289 1 4.11111C1 5.82934 2.34314 7.22222 4 8Z",
    stroke: "#3E4159",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3254f6a5090f94db35be6668f1d70814.svg";
export { ForwardRef as ReactComponent };